import { styled, Drawer as MaterialDrawer, IconButton } from '@mui/material';

import {
    renderedComponentPropType,
    functionalComponentPropType,
} from '@libs/propTypes';
import useNavigation from '../useNavigation';
import Routes from './Routes';
import { useLogoRef, useDrawerStyle, useDrawerHover } from './hooks';
import { useCallback } from 'react';
import CloseIcon from '@mui/icons-material/Close';

const propTypes = {
    FullLogoComponent: renderedComponentPropType.isRequired,
    CompactLogoComponent: functionalComponentPropType.isRequired,
};

const StyledDrawerPaper = styled(MaterialDrawer)(
    ({ theme: { transitions } }) => ({
        '& .MuiDrawer-paper': {
            width: 'var(--drawerWidth)',
            minWidth: 0,
            overflow: 'hidden',
            transition: transitions.create('width', {
                easing: transitions.easing.sharp,
                duration: transitions.duration.shorter,
            }),
            '& *:focus, & *:focus-visible, & *.Mui-focusVisible': {
                outline: 'none !important',
                boxShadow: 'none !important'
            }
        },
    })
);
const Container = styled('div')(({ theme }) => ({
    display: 'flex',
    height: 'calc(100% - var(--logoHeight))',
    flexDirection: 'column',
    gap: 0,
    backgroundColor: theme.palette.secondary.main,
    minWidth: 'var(--drawerFullWidth)'
}));
const LogoWrapper = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 'var(--logoHeight)',
    minWidth: 'var(--drawerFullWidth)'
});

const Drawer = ({ FullLogoComponent, CompactLogoComponent }) => {
    const [{ isDrawerVisible, isDrawerMinified, isDrawerFloating, routes },dispatch] =  useNavigation();
    const logoRef = useLogoRef();
    const [handleMouseEnter, handleMouseLeave] = useDrawerHover();

    const handleMenu = useCallback(
        () =>
            dispatch({
                type: 'setDrawerVisibility',
                payload: !isDrawerVisible,
            }),
        [dispatch, isDrawerVisible]
    );

    return (
        <StyledDrawerPaper
            variant='permanent'
            style={useDrawerStyle()}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <LogoWrapper sx={{ backgroundColor: 'background.white' }} ref={logoRef}>
                {isDrawerMinified && !isDrawerFloating ? (
                    <CompactLogoComponent />
                ) : (
                    <FullLogoComponent ref={logoRef} />
                )}
            </LogoWrapper>
            <Container sx={{ overflowY: 'auto' }}>
                <IconButton
                    sx={{ position: 'absolute', right: '8px', color: 'text.success', display: { xs: 'inline-flex', md: 'none' } }}
                    onClick={handleMenu}
                >
                    <CloseIcon />
                </IconButton>
                {routes.map((menuGroup, index) => {
                    if (!menuGroup.groupName) return null;
                    return (
                        <Routes key={`menu-group-${index}`} {...menuGroup} />
                    )
                })}
                {/* <ToggleButton /> */}
            </Container>
        </StyledDrawerPaper>
    );
};

Drawer.propTypes = propTypes;

export default Drawer;
